import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_CALLS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Calls = lazy(() =>
  import('../../../screens/Calls')
    .then(module => ({default: module.Calls})));

const CallNavigation = [
  {
    path: ROUTE_CALLS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Calls />
      </Suspense>
    ),
  },
];

export default CallNavigation;
